import { useOrgData } from "../../../../../../contexts/OrgDataContext";
import { getText, LOGS_TYPES } from "../../../../../../services/log/log-service";
import { useMemo } from "react";
import moment from "moment/moment";
import { ExclamationTriangleIcon, InformationCircleIcon } from "@heroicons/react/20/solid";
import Badge from "../../../../../../components/badges/Badge";
import { formatSecondsToHMS } from "../../../../../../helpers/date/date-helper";
import { JOURNAL_DISPLAY_NON_CONFORMITY_ONLY } from "../../../../../../services/journal/journal-service";
import { useJournal } from "../../../../../../contexts/JournalContext";

export const LISILog = ({ log, patternExecutions }) => {

  const { type, time } = log;
  const { eventTypes } = useOrgData();
  const { selectedDisplayOption } = useJournal();

  const tsMs = new Date(log?.time).getTime() / 1000;
  const patternExecution = patternExecutions
    .find(({ start_date, stop_date }) => log.type !== LOGS_TYPES.ALERT && tsMs >= start_date && tsMs <= stop_date) ?? null;

  let patternExecutionName = 'Pièce hors gamme';

  let isOvenTimeTooShort = false, isOvenTimeTooLong = false, isTransferTimeTooLong = false;
  if (patternExecution !== null) {
    const patternData = patternExecution?.pattern?.pattern_data.reduce((acc, { name, value }) => ({ ...acc, [name]: value }), {});
    patternExecutionName = patternExecution.pattern.name;

    isOvenTimeTooShort = log?.data_oven_time < parseInt(patternData.oven_time) - parseInt(patternData.oven_tolerance);
    isOvenTimeTooLong = parseInt(patternData.oven_time) + parseInt(patternData.oven_tolerance) < log?.data_oven_time;
    isTransferTimeTooLong = parseInt(patternData.transfer_time) + parseInt(patternData.transfer_tolerance) < log?.data_transfer_time;
  }
  const pieceIsOk = !isOvenTimeTooShort && !isOvenTimeTooLong && !isTransferTimeTooLong;

  if (selectedDisplayOption.id === JOURNAL_DISPLAY_NON_CONFORMITY_ONLY && pieceIsOk)
    return null;

  const isAlert = type === LOGS_TYPES.ALERT;

  const circleColor = !pieceIsOk ? 'bg-perception-warn-500' : isAlert ? 'bg-perception-error-500' : 'bg-perception-black-900';
  const textColor = !pieceIsOk ? 'text-perception-warn-500 font-medium' : isAlert ? 'text-perception-error-500 font-medium' : '';

  return useMemo(() => (
    <div className="ml-8 border-l-1 border-perception-gray-600 relative flex pb-2 pr-4">

      {/* Circle */}
      <div className="absolute size-3 top-0 -left-1.5 rounded-full bg-perception-gray-500">
        <div className={`size-2 ${circleColor} absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full`}/>
      </div>

      {/* Datetime */}
      <div className="text-sm -mt-1 w-32 text-center">
        {moment(time).format('HH:mm:ss')}
      </div>

      {/* Log content */}
      <div className="flex-1 bg-perception-black-800 px-4 pr-1 py-1 rounded-md flex justify-between items-center">
        <div className="flex items-center gap-4">
          {
            isAlert ?
              <ExclamationTriangleIcon className={`size-4 min-w-4 ${textColor}`}/>
              :
              <InformationCircleIcon className={`size-4 min-w-4 ${textColor}`}/>
          }
          <div className={`text-sm ${textColor} flex gap-2`}>
            {getText(log, {}, true, eventTypes)}
            {log?.data_piece_id !== null && <Badge text={`#${log?.data_piece_id}`} />}
          </div>
        </div>
        <div className="flex gap-2">
          {!isAlert &&
            <div className="grid grid-cols-4 gap-2">
              <Badge text={patternExecutionName} />
              <Badge
                text={`Chauffe : ${formatSecondsToHMS(log?.data_oven_time) || '-'}`}
                type={(isOvenTimeTooShort || isOvenTimeTooLong) ? 'yellow' : patternExecution !== null ? 'green' : 'gray'}
              />
              <Badge
                text={`Four <> Frappe : ${formatSecondsToHMS(log?.data_transfer_time) || '-'}`}
                type={isTransferTimeTooLong ? 'yellow' : patternExecution !== null ? 'green' : 'gray'}
              />
              <Badge
                text={`Frappe <> Découpe : ${formatSecondsToHMS(log?.data_transfer_hit_cut_time) || '-'}`}
                type={patternExecution !== null ? 'green' : 'gray'}
              />
            </div>
          }
          {isAlert && <Badge text="Alerte levée" type="red" />}
        </div>
      </div>

    </div>
  ), [log, eventTypes]);
};